import { render, staticRenderFns } from "./appraise_detail.vue?vue&type=template&id=533ec3da&scoped=true"
import script from "./appraise_detail.vue?vue&type=script&lang=js"
export * from "./appraise_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ec3da",
  null
  
)

export default component.exports